module.exports = __webpack_public_path__ + "static/img/16.87adc0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/16.jpg
// module id = 8Fz4
// module chunks = 0